<ng-container *ngIf="showOnlyMainPart; else elseTemplate">
  <div placement="right">
    <svg xmlns="http://www.w3.org/2000/svg" width="3.1rem" height="3.1rem" viewBox="0 0 18 18">
      <path
        d="M5.56 14.44l1.06 1.06L9 13.12l2.38 2.38 1.06-1.06L9 11l-3.44 3.44zm6.88-10.88L11.38 2.5 9 4.88 6.62 2.5 5.56 3.56 9 7l3.44-3.44z" />
    </svg>
  </div>
</ng-container>

<ng-template #elseTemplate>
  <div placement="right">
    <svg xmlns="http://www.w3.org/2000/svg" width="3.1rem" height="3.1rem" viewBox="0 0 18 18">
      <path
        d="M9 4.12l2.38 2.38 1.06-1.06L9 2 5.56 5.44 6.62 6.5 9 4.12zm0 9.76L6.62 11.5l-1.06 1.06L9 16l3.44-3.44-1.06-1.06L9 13.88z" />
    </svg>
  </div>
</ng-template>